import React, { useEffect } from 'react';
import { cnTheme } from '@carnica/themes';
import classNames from 'classnames/bind';
import { compose } from '@beef/utils';
import { withMountListener } from '@beef/react/enhancers';
import { connect } from 'react-redux';
import { Link } from '@beef/ui-kit';
import { pushTopEvAnalytics } from "../../../../utils";
import { ActionCreator } from "../../../store/actions";
import styles from "./styles.pcss";
import { Item } from "./components/Item";
import { AUTH_LINK, TEXTS } from "./constants";
import { AppBanner } from "./components/AppBanner";
import LogoLogin from "./assets/login.svg";
var cn = classNames.bind(styles);
var theme = cnTheme('dark');
export var NonAuth_ = function NonAuth_(_ref) {
  var isOpen = _ref.isOpen;
  var handleAuthClick = function handleAuthClick() {
    if (window) {
      pushTopEvAnalytics({
        action: 'click',
        item_type: 'element',
        element_text: 'личный кабинет на сайте',
        popup_title: 'выберите способ входа'
      });
    }
  };
  useEffect(function () {
    if (isOpen && window) {
      pushTopEvAnalytics({
        action: 'view',
        item_type: 'popup',
        popup_title: 'выберите способ входа'
      });
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    className: cn('wrapper', theme),
    "data-t-id": "Container-NonAuth"
  }, /*#__PURE__*/React.createElement(Link, {
    href: AUTH_LINK,
    onClick: handleAuthClick
  }, /*#__PURE__*/React.createElement(Item, {
    Icon: LogoLogin,
    subTitle: TEXTS.SITE,
    title: TEXTS.TITLE,
    "data-t-id": "Container-NonAuth"
  })), /*#__PURE__*/React.createElement(Item, {
    subTitle: TEXTS.MOBILE,
    title: TEXTS.TITLE
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('banner'),
    "data-t-id": "Container-NonAuth"
  }, /*#__PURE__*/React.createElement(AppBanner, null))));
};
var mapDispatchToProps = {
  onMount: ActionCreator.fetchNotAuthData
};
export var NonAuth = compose(connect(null, mapDispatchToProps), withMountListener)(NonAuth_);